import { FindNextGameRepository } from "../../data/find-next-game-repository";
import { NextGame } from "../../domain/use-case/next-game";
import { AxiosAdapter } from '../../infra/adapters/axios-adpter';

export function makeNextGameUseCase () {
  const axiosAdapter = new AxiosAdapter()
  const findNextGameRepository = new FindNextGameRepository(axiosAdapter, 'https://api.cdt.casadebraganca.com/next-game')
  return new NextGame(findNextGameRepository)
}